import { assessmentsConstants } from '../../_constants';
import { assessmentsService } from '../../_services';



export const onSubmitAssessmentAction = {
    onSubmitAssessmentHandler
};

function onSubmitAssessmentHandler(data, currentDashboardObj, callback) {
    return dispatch => {
        dispatch(request());
        assessmentsService.onSubmitAssessmentHandler(data, currentDashboardObj)
            .then(
                onSubmitAssessment => {
                    dispatch(success(onSubmitAssessment));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: assessmentsConstants.REQUEST_ASSESSMENT_SUBMIT } }
    function success(onSubmitAssessment) { return { type: assessmentsConstants.RECEIVE_ASSESSMENT_SUBMIT, onSubmitAssessment } }
    function failure(error) { return { type: assessmentsConstants.ASSESSMENT_SUBMIT_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/Assessments/submitAssessment.action.js